import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

export default CancelRoundedIcon;
